// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"aec29e9f","85":"9f1db0ad","488":"dd8b2d40","784":"53409943","889":"ff3e5658"}[chunkId] + ".chunk.js";
};